export const ItemSummaryTable = ({
    title,
    data,
    totalItems,
    missingItems,
    percentage,
    onRowClick,
    sortByNameAsc
}) => {
    return (
        <div className="border p-2">
            <div className="font-semibold mb-1.5 text-sm text-center tracking-wider">{title}</div>

            <div className="rounded-md border overflow-x-auto max-h-[300px] tiny-scrollbar">
                <table className="min-w-full overflow-y-auto divide-y divide-gray-200 text-xs text-center">
                    <thead className="bg-gray-100 top-0 z-10 sticky">
                        <tr>
                            <th className="px-1 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">Item Name</th>
                            <th className="px-1 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">Sold</th>
                        </tr>
                    </thead>

                    <tbody className="bg-white divide-y divide-gray-100">
                        {data?.length > 0 ? (
                            sortByNameAsc(data, "ItemName").map((item, index) => (
                                <tr
                                    key={index}
                                    className={`hover:bg-gray-50 hover:underline cursor-pointer ${!item.has_recipe
                                        ? 'bg-red-100 text-red-700 hover:text-red-800'
                                        : ''
                                        }`}
                                    onClick={() => onRowClick(item)}
                                >
                                    <td className="px-3 py-1 tracking-wide">{item.ItemName}</td>
                                    <td className="px-3 py-1 tracking-wide">{item.total_sold}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={2} className="px-3 py-4 text-gray-500">
                                    No data available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <div className="mt-2 p-1 space-y-1">
                <div className="grid grid-cols-2 gap-2 items-center">
                    <label>Total items :</label>
                    <input readOnly value={totalItems} className="border p-1 rounded w-full font-semibold text-center" />

                    <label>Missing items :</label>
                    <input readOnly value={missingItems} className="border p-1 rounded w-full font-semibold text-center" />

                    <label>Accuracy :</label>
                    <input
                        readOnly
                        value={`${percentage}%`}
                        className={`border p-1 rounded w-full font-semibold text-center ${percentage < 80
                            ? 'bg-red-200 text-red-800'
                            : percentage <= 90
                                ? 'bg-yellow-200 text-yellow-800'
                                : 'bg-green-200 text-green-800'
                            }`}
                    />
                </div>
            </div>
        </div>
    );
};